import { AuthProvider } from "@contexts/auth/AuthContext";
import { CompanyProvider } from "@contexts/company/CompanyContext";
import { FingerprintProvider } from "@contexts/fingerprint/FingerprintContext";
import RoutesLoading from "@providers/RoutesLoadingProvider";
import { ReactNode } from "react";
import ToastProvider from "@components/common/ui/Toast/Context";
import { UserProvider } from "@contexts/user/UserContext";

export default function Providers({ children, pageProps }: { children: ReactNode; pageProps: any }) {
  return (
    <>
      <FingerprintProvider>
        <ToastProvider>
          <UserProvider>
            <AuthProvider>
              <CompanyProvider>
                <RoutesLoading>{children}</RoutesLoading>
              </CompanyProvider>
            </AuthProvider>
          </UserProvider>
        </ToastProvider>
      </FingerprintProvider>
    </>
  );
}
